import { Component, OnInit, Renderer2 } from '@angular/core';
declare var Hls: any;
@Component({
  selector: 'app-multiplayertest',
  templateUrl: './multiplayertest.component.html',
  styleUrls: ['./multiplayertest.component.css']
})
export class MultiplayertestComponent implements OnInit {
  streamUrls: string[] = [
    "https://media22.cloudcam.vn/cloud-camera/admin_shopee1646612121218.stream/playlist.m3u8",
    "https://media31.cloudcam.vn/cloud-camera/admin_shopee1732775408758.stream/playlist.m3u8",
     "https://media31.cloudcam.vn/cloud-camera/admin_shopee1693970678100.stream/playlist.m3u8",
     "https://media26.cloudcam.vn/cloud-camera/admin_shopee1734060217174.stream/playlist.m3u8",
     "https://media25.cloudcam.vn/cloud-camera/admin_shopee1734060224646.stream/playlist.m3u8",
     "https://media07.cloudcam.vn/cloud-camera/admin_shopee1734060248489.stream/playlist.m3u8",
     "https://media06.cloudcam.vn/cloud-camera/admin_shopee1656485060179.stream/playlist.m3u8",
    "https://media32.cloudcam.vn/cloud-camera/IDhiFU9132460_record/playlist.m3u8",
    "https://media32.cloudcam.vn/cloud-camera/IDhiFU9132375_record/playlist.m3u8",
    // "https://media08.cloudcam.vn/cloud-camera/IDhiF24769522_record/playlist.m3u8",
    // "https://media08.cloudcam.vn/cloud-camera/IDhiF24769522_record/playlist.m3u8",
    // "https://media07.cloudcam.vn/cloud-camera/IDhiFU9132292_record/playlist.m3u8",
    // "https://media18.cloudcam.vn/cloud-camera/IDhiFU9132281_record/playlist.m3u8",
    // "https://media32.cloudcam.vn/cloud-camera/IDhiFU9132456_record/playlist.m3u8",
    // "https://media09.cloudcam.vn/cloud-camera/IDhiFU9132455_record/playlist.m3u8",
    // "https://media22.cloudcam.vn/cloud-camera/admin_shopee1646612121218.stream/playlist.m3u8",
    // "https://media22.cloudcam.vn/cloud-camera/admin_shopee1646612121218.stream/playlist.m3u8",
    // "https://media22.cloudcam.vn/cloud-camera/admin_shopee1646612121218.stream/playlist.m3u8",
    // "https://media22.cloudcam.vn/cloud-camera/admin_shopee1646612121218.stream/playlist.m3u8",
    // "https://media31.cloudcam.vn/cloud-camera/IDhiFU9132306_record/playlist.m3u8",
    // "https://media08.cloudcam.vn/cloud-camera/IDhiF24769522_record/playlist.m3u8",
    // "https://media08.cloudcam.vn/cloud-camera/IDhiF24769522_record/playlist.m3u8"
  ];
  constructor(private renderer: Renderer2) { }

  ngOnInit(): void { 
       this.streamUrls.forEach((url, i) => {
      setTimeout(() => this.initPlayer(url, i), i * 800);
    });
  }
  initPlayer(url: string, i: number) {
    const wrapper = this.renderer.createElement('div');
    wrapper.className = 'player-wrapper';
    wrapper.innerHTML = `
      <video id="video${i}" muted autoplay playsinline crossorigin="anonymous"></video>
    `;
   const container = document.querySelector('.video-grid');
container?.appendChild(wrapper);

    const video = wrapper.querySelector('video') as HTMLVideoElement;

    const hls = new Hls({
      lowLatencyMode: true,
      maxBufferLength: 5,
      maxMaxBufferLength: 10,
      maxBufferSize: 10 * 1024 * 1024,
      liveSyncDurationCount: 2,
      backBufferLength: 5,
      maxBufferHole: 0.5,
      startFragPrefetch: true,
      enableWorker: true,
      fragLoadingRetryDelay: 1000,
      fragLoadingMaxRetry: 6,
      manifestLoadingRetryDelay: 1000,
      manifestLoadingMaxRetry: 5
    });

    hls.loadSource(url);
    hls.attachMedia(video);

    hls.on(Hls.Events.ERROR, (event: any, data: any) => {
      if (data.fatal) {
        switch (data.type) {
          case Hls.ErrorTypes.NETWORK_ERROR:
            hls.startLoad(); break;
          case Hls.ErrorTypes.MEDIA_ERROR:
            hls.recoverMediaError(); break;
          default:
            hls.destroy();
            // this.initPlayer(url, i); break;
        }
      }
    });

  }
}
